import '@trimble-agentic-internal-npm-local/agentic-chat-ui/style.css';
import ReactDOM from 'react-dom/client';
import './index.css';

import { EmbeddedApp } from './EmbeddedApp';
import { initAnalytics } from './utilities/analytics';
import './i18n';

const mode = import.meta.env.MODE;
// `vite build --mode dev` sets DEV=false (NODE_ENV=production) but MODE=dev.
if (mode !== 'dev' && mode !== 'development') {
  initAnalytics({
    measurementId: import.meta.env.VITE_GTAG_ID,
  });
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(<EmbeddedApp />);
